export default __webpack_public_path__ + "i18n/translations/translation-sv.a7c83ba1.json";